const BASE_ENDPOINT = "https://dserver.tradebid.click";

export { BASE_ENDPOINT }